import { render } from "./ErrorCartExpired.vue?vue&type=template&id=1eb3afa2"
import script from "./ErrorCartExpired.vue?vue&type=script&lang=js"
export * from "./ErrorCartExpired.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__